// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FacebookFilledSvg from "@fishx/icons-svg/es/asn/FacebookFilled";
import FishxIcon from '../components/FishxIcon';

var FacebookFilled = function FacebookFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FacebookFilledSvg
  }));
};

FacebookFilled.displayName = 'FacebookFilled';
export default React.forwardRef(FacebookFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FacebookFilled.js
// module id = 2664
// module chunks = 0